// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CatalogPerson } from './catalogPerson.zod.ts';

export const HistoryEvent = zod.object({
  "action": zod.string(),
  "actor": zod.union([CatalogPerson,zod.null()]),
  "at": zod.iso.datetime({"offset":true}),
  "audience": zod.string(),
  "case_id": zod.union([zod.uuid(),zod.null()]),
  "changes": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "id": zod.uuid()
});

export type HistoryEvent = zod.input<typeof HistoryEvent>;
export type HistoryEventOutput = zod.output<typeof HistoryEvent>;
